<template>
  <v-dialog v-model="dialogComputed" max-width="400px" persistent>
    <v-card>
      <v-card-title class="primary white--text py-2" primary-title>
        {{ $t('ELE0037') }}
      </v-card-title>
      <v-card-text class="text-h7 text--primary py-2">
        <div style="white-space: pre-line">{{ confirmWord }}</div>
        <br />
        <br />
        {{ confirmLastWord }}
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <Btn :label="$t('ELE0038')" @click="onClickCancel" />
        <v-spacer />
        <Btn :label="btnLabel" :color="btnColor" @click="onProceed" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Btn from '@/components/atoms/base/button/Btn'

export default {
  name: 'ConfirmDialog',
  components: { Btn },
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    confirmWord: {
      type: String,
      required: true,
    },
    confirmLastWord: {
      type: String,
      required: false,
      default: function () {
        return this.$t('MSG0012')
      },
    },
    btnLabel: {
      type: String,
      required: true,
    },
    btnColor: {
      type: String,
      required: false,
      default: 'primary',
    },
  },
  computed: {
    dialogComputed: {
      get() {
        return this.dialog
      },
      set(value) {
        this.$emit('update:dialog', value)
      },
    },
  },
  methods: {
    onProceed() {
      this.$emit('proceed')
    },
    onClickCancel() {
      this.$emit('cancel')
    },
  },
}
</script>
